import { render, staticRenderFns } from "./despatched-list.vue?vue&type=template&id=50c9601e&"
import script from "./despatched-list.vue?vue&type=script&lang=js&"
export * from "./despatched-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports